import { axios } from "@Root/API";

export const deleteStudiesStudyProgramme = studyProgrammeId => {
  return axios.delete(`delete/student-course-session/${studyProgrammeId}`);
};
